export default __webpack_public_path__ + "static/media/3692.ebf0f407.png";